import React, { FC, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Image } from "antd";
import { ProudctActionDetail } from "../../api/sku";
import { productdatahelperSingle } from "../../helpers/products.helper";
import { fallback } from "../../constants/image.constant";
import "./test.scss";
const ProductActionImage: FC = () => {
  const { activeSection, skuId }: any = useParams();
  const [info, setInfo] = useState<any>({});
  useEffect(() => {
    ProudctActionDetail(activeSection, skuId).then((res) => {
      if (res.status === 200) {
        activeSection === "sku"
          ? setInfo(res.data)
          : setInfo(productdatahelperSingle(res.data));
      }
    });
  }, []);
  return (
    <>
      <Image
        style={{ width: "100%" }}
        src={info.imageUrl ? info.imageUrl : ""}
        placeholder={<Image preview={false} src={info.imageUrl} />}
        fallback={fallback}
      />
    </>
  );
};

export default ProductActionImage;
